import {getAlias, getPoslogs} from "../../../requesters/apiV3Requesters";
import {NOTIFICATION_NS} from "@/store/modules/notification/constants";

const actions = {
    toggleBusinessUnitPanel({commit, dispatch, getters}) {
        commit('toggleBusinessUnitPanel')
        if (!getters.isBusinessUnitPanelVisible) {
            dispatch('searchIfDirty');
        }
    },
    toggleDateTimePanel({commit, dispatch, getters}) {
        commit('toggleDateTimePanel')
        if (!getters.isDateTimePanelVisible) {
            dispatch('searchIfDirty');
        }
    },
    updateDateTabItem({commit}, tabIndex) {
        commit('updateDateTabItem', tabIndex)
    },
    toggleFiltersPanel({commit, dispatch, getters}) {
        commit('toggleFiltersPanel')
        if (!getters.isFiltersPanelVisible) {
            dispatch('searchIfDirty');
        }
    },
    refreshAlias({commit}) {
        getAlias()
            .then(listAlias => {
                listAlias = listAlias.data.map(alias => {
                    return {title: alias, value: "", operator: "="}
                });
                commit("updateAlias", listAlias);
            });
    },

    // Filters
    updateFilters({commit}, filters) {
        commit('updateFilters', filters);
    },
    updateFilter({commit}, filter) {
        commit('updateFilter', filter);
    },
    addFilter({commit, dispatch}, filter) {
        commit('addFilter', filter);

        dispatch(
            `${NOTIFICATION_NS}/addNotification`,
            {
                message: `Filter added : ${filter.label} ${filter.operator} ${filter.value}`
            },
            {root: true}
        );
    },
    removeFilter({commit}, filter) {
        commit('removeFilter', filter);
    },

    // Search Query
    updateSearchQueryStr({commit}, payload) {
        commit('updateSearchQueryStr', payload);
    },

    // Date
    updatePeriod({commit}, payload){
        commit('updateBeginDate', payload.begin);
        commit('updateEndDate', payload.end);
    },
    updateBeginDate({commit}, payload) {
        commit('updateBeginDate', payload);
    },
    updateEndDate({commit}, payload) {
        commit('updateEndDate', payload);
    },

    // Poslog
    gotToPage({state, commit, dispatch}, page) {
        commit('updatePoslogsTableOptions', {
            ...state.poslogsTableOptions,
            page: page ? page : 1
        });
        dispatch('searchPosLogsData');
    },
    updatePoslogsTableOptions({commit, dispatch}, payload) {
        commit('updatePoslogsTableOptions', payload);
        dispatch('searchPosLogsData');
    },
    searchIfDirty({dispatch, getters}) {
        if(getters.isDirtySearch) {
            dispatch('gotToPage');
        }
    },
    searchPosLogsData({state, commit, getters}) {
        commit("toggleLoading");

        const beginDate = getters.ignoreDate ? false : state.beginDate;
        const endDate = getters.ignoreDate ? false : state.endDate;

        getPoslogs(beginDate, endDate, getters.searchQuery, getters.enabledFilters, state.poslogsTableOptions)
            .then(apiPoslogsReturn => {
                commit("toggleLoading");
                commit("updateIsDirtySearch", false);
                commit("updateNbMaxPoslogs", apiPoslogsReturn.nbMaxPoslogs);
                return commit("updatePoslogsList", apiPoslogsReturn.posLogs)
            });
    }
};

export default actions;
